/**
 * Which orders view an organisation gets. Decided by zeecore
 * (`GET /orders/v1/availability`, projections/orders-daily/availability.ts)
 * from the same facts its computation uses; the app only maps the answer to
 * a view and never looks at source names.
 *
 * - `available`: Order Flow Intelligence (the orders_daily board).
 * - `not_set_up`: the board reads this org's order system, but something it
 *   needs is missing (e.g. no site marked as the org's own); the server's
 *   message says what, shown as "Not available yet".
 * - `legacy`: no order system the board reads; the older orders view stays.
 * - `loading`: not answered yet (or the check failed and is being retried).
 */

export type OrdersDailyAvailability =
  | { status: 'available' }
  | { status: 'not_set_up'; message: string }
  | { status: 'not_supported' };

export type OrdersDailySupport = 'loading' | 'available' | 'not_set_up' | 'legacy';

export function ordersDailySupport(availability: OrdersDailyAvailability | null | undefined): OrdersDailySupport {
  if (!availability) return 'loading';
  if (availability.status === 'available') return 'available';
  if (availability.status === 'not_set_up') return 'not_set_up';
  return 'legacy';
}

/** The server's words for why the board isn't available yet, when it gave some. */
export function ordersNotAvailableMessage(availability: OrdersDailyAvailability | null | undefined): string | undefined {
  return availability?.status === 'not_set_up' ? availability.message : undefined;
}
